import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './views/app.component';

//Material
import { AppRoutingModule } from './app-routing.module';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { NotFoundComponent } from './views/pages/not-found/not-found.component';
import { ForbiddenComponent } from './views/pages/forbidden/forbidden.component';
import { HelpersService } from './core/services/helpers.service';
import { NotificationHelper } from './core/services/helpers/notification.helper';
import { RequestsService } from './core/services/requests.service';
import { QueriesService } from './core/services/queries.service';
import { AuthLayoutComponent } from './views/layouts/auth-layout/auth-layout.component';
import { AuthModule } from './modules/auth/auth.module';
import { AdminModule } from './modules/admin/admin.module';
import { AdminLayoutComponent } from './views/layouts/admin-layout/admin-layout.component';
import { FooterComponent } from './views/layouts/components/footer/footer.component';
import { HomeLayoutComponent } from './views/layouts/home-layout/home-layout.component';
import { NavbarComponent } from './views/layouts/components/navbar/navbar.component';
import { SidebarComponent } from './views/layouts/components/sidebar/sidebar.component';
import { MenuService } from './core/services/menu.service';
import { getFromLocal } from './core/services/functions.service';
import { ImportsModule } from './modules/shared/imports/imports.module';
import { SearchComponent } from './views/layouts/components/search/search.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { CardModuleComponent } from './modules/shared/card-module/card-module.component';
import { TruncateDirective } from './modules/shared/directives/truncate.directive';
import { ScrollVisibilityDirective } from './modules/shared/scroll-visibility.directive';
// import { IndicadoresComponent } from './modules/admin/modules/indicadores/indicadores.component';

@NgModule({
  declarations: [
    AppComponent,
    //Default pages
    NotFoundComponent,
    ForbiddenComponent,
    //layouts
    AuthLayoutComponent,
    HomeLayoutComponent,
    AdminLayoutComponent,
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    SearchComponent,
    CardModuleComponent,
    ScrollVisibilityDirective,
    TruncateDirective,
  
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    AppRoutingModule,
    AuthModule,
    AdminModule,
    MatDividerModule,

    //card
    MatCardModule,
    
    //Own
    ImportsModule,
    //material
    JwtModule.forRoot({
      config: {
        tokenGetter: () => {
          return getFromLocal(environment.COOKIE_TOKEN)
        },
        authScheme: "Bearer",
        allowedDomains: environment.allowedDomains,//Rutas a las que siempre se enviará el token
        disallowedRoutes: environment.disallowedRoutes,//Rutas a las que no se debe enviar el token

      },

    }),
  ],

  providers: [HelpersService, NotificationHelper, RequestsService, QueriesService, MenuService],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
